import InfoIcon from "@material-ui/icons/Info";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { IRoute } from "src/common/typings/routes";
import { Commercial } from "./nod-Commercial";
import { PaymentsList } from "./pages/PaymentsList";
import { TerminalCharges } from "./pages/TerminalCharges/TerminalCharges";
import { ForwarderWiseCharges } from "./pages/ForwarderWiseCharges";
import { ImporterWiseCharges } from "./pages/ImporterWiseCharges";

export const NodCommercialRoute: IRoute = {
  title: "Commercial",
  path: "/nod/commercial",
  icon: LocalOfferIcon,
  component: Commercial,
  guard: true,
  subRoutes: [
    {
      icon: InfoIcon,
      component: TerminalCharges,
      path: "/generate-invoices",
      title: "Generate Invoices",
    },
    {
      icon: InfoIcon,
      component: ForwarderWiseCharges,
      path: "/forwarder-invoice",
      title: "Forwarder Wise Invoice",
    },
    {
      icon: InfoIcon,
      component: ImporterWiseCharges,
      path: "/party-invoice",
      title: "Importer Wise Invoice",
    },
    {
      icon: InfoIcon,
      component: PaymentsList,
      path: "/invoices",
      title: "Invoices",
    },
  ],
};
